module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('router-view'), _vm._v(" "), _c('footer', [_c('footer-bar')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-021c21a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 119
// module chunks = 0